"use client"

import type { RelativeTimeOptions } from "@opensea/i18n"
import { Chip } from "@opensea/ui-kit"
import { useTranslations } from "next-intl"
import { LiveTimestamp } from "@/components/activity-feed/LiveTimestamp"

type Props = {
  time: Date | null
  className?: string
  showTooltip?: boolean
} & RelativeTimeOptions

function CountdownLabel({
  time,
  showTooltip = true,
  ...relativeTimeOptions
}: Props) {
  const t = useTranslations("Countdown")
  return (
    <LiveTimestamp
      date={time}
      futurePrefix={t("ending")}
      pastPrefix={t("ended")}
      showTooltip={showTooltip}
      {...relativeTimeOptions}
    />
  )
}

export function CountdownChip({
  className,
  showTooltip = true,
  ...props
}: Props) {
  return (
    <Chip className={className}>
      <CountdownLabel showTooltip={showTooltip} {...props} />
    </Chip>
  )
}
